import { render, staticRenderFns } from "./gestionesReconocimientoFacial.vue?vue&type=template&id=68b905d3&scoped=true"
import script from "./gestionesReconocimientoFacial.vue?vue&type=script&lang=js"
export * from "./gestionesReconocimientoFacial.vue?vue&type=script&lang=js"
import style0 from "./gestionesReconocimientoFacial.vue?vue&type=style&index=0&id=68b905d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b905d3",
  null
  
)

export default component.exports